export enum TabType {
  SCRIPT,
  WEBCHAT,
  PREPAUSE,
  STATUS,
  TRANSFERENCE,
  DIALER,
  UDA,
}
